export default __webpack_public_path__ + "static/media/Teachersday4.de1164d2.JPG";